<div class="header-container">
  <div class="logo-container">
    <a
      href="#"
      class="sidebar-toggle"
      matRipple
      [matRippleUnbounded]="true"
      [matRippleCentered]="true"
      (click)="toggleSidebar()"
    >
      <nb-icon [icon]="(materialTheme$ | async) ? 'menu-outline' : 'menu-2-outline'"></nb-icon>
    </a><a class="logo" href="#" (click)="navigateHome()">
      <img src="/ware/logo/logo.jpg" alt="FreshIA" class="logo-img">
      FreshIA
    </a>
  </div>
  <nb-select
    status="primary"
    matRipple
    [selected]="currentTheme"
    (selectedChange)="changeTheme($event)"
  >
    <nb-option
      *ngFor="let theme of themes"
      [value]="theme.value"
      matRipple
    >{{ theme.name }}</nb-option>
  </nb-select>
</div>

<div class="header-container">
  <nb-actions size="small">

    <nb-action
      class="control-item refresh-action"
      icon="refresh-outline"
      matRipple
      [matRippleUnbounded]="true"
      [matRippleCentered]="true"
      title="Recargar aplicación"
      (click)="forceRefreshApp()"
    ></nb-action>

    <nb-action
      class="control-item fullscreen-action"
      [icon]="isFullscreen ? 'collapse-outline' : 'expand-outline'"
      matRipple
      [matRippleUnbounded]="true"
      [matRippleCentered]="true"
      [title]="isFullscreen ? 'Salir de pantalla completa' : 'Pantalla completa'"
      (click)="toggleFullscreen()"
    ></nb-action>

    <nb-action class="control-item">
      <nb-search
        type="rotate-layout"
        placeholder="Buscar Palet..."
        matRipple
        [matRippleUnbounded]="true"
        [matRippleCentered]="true"
      ></nb-search></nb-action>
    <nb-action
      class="control-item notification-bell"
      [icon]="notificacionesActivas ? 'bell-outline' : 'bell-off-outline'"
      [style.color]="notificacionesActivas ? 'currentColor' : '#d3d3d3'"
      matRipple
      [matRippleUnbounded]="true"
      [matRippleCentered]="true"
      (click)="toggleNotifications()"
      title="Click para habilitar/deshabilitar notificaciones push"
    ></nb-action>
    <nb-action
      class="location-action"
      matRipple
      [matRippleUnbounded]="true"
      [matRippleCentered]="true"
      [title]="getUbicacionSeleccionadaLabel() + ' · ' + getCamaraSeleccionadaLabel()"
      (click)="openUbicacionModal()">
      <nb-icon icon="pin-outline"></nb-icon>
      <span class="location-action__label">{{ getCamaraSeleccionadaLabel() }}</span>
    </nb-action>
    <nb-action
      class="user-action"
      *nbIsGranted="['view', 'user']"
      matRipple
      [matRippleUnbounded]="true"
      [matRippleCentered]="true">
      <nb-user [nbContextMenu]="userMenu"
               [onlyPicture]="userPictureOnly"
               [name]="userIdentifier || userEmail || 'Usuario'"
               [title]="userEmail && userEmail !== userIdentifier ? userEmail : ''"
               [picture]="'https://cdn-icons-png.flaticon.com/512/149/149071.png'">
      </nb-user>
    </nb-action>
    <nb-action *ngIf="mostrarEntornoPruebas" class="env-badge-action">
      <span class="env-badge">EN PRUEBAS</span>
    </nb-action>
  </nb-actions>
</div>

<ng-template #ubicacionDialog>
  <nb-card class="location-dialog">
    <nb-card-body class="location-dialog__body">
      <div class="location-dialog__field">
        <label>Seleccionar ubicación</label>
        <nb-select
          fullWidth
          status="primary"
          placeholder="Ubicación"
          [selected]="ubicacionTemporal"
          (selectedChange)="onUbicacionTemporalChange($event)">
          <nb-option *ngFor="let u of ubicaciones" [value]="u">
            {{ u.nombre || u.name || ('Ubicación ' + u.id) }}
          </nb-option>
        </nb-select>
      </div>

      <div class="location-dialog__field">
        <label>Seleccionar cámara</label>
        <nb-select
          fullWidth
          status="primary"
          placeholder="Cámara"
          [disabled]="cargandoCamarasModal || !ubicacionTemporal"
          [selected]="camaraTemporal"
          (selectedChange)="onCamaraTemporalChange($event)">
          <nb-option *ngFor="let c of camarasModal" [value]="c">
            {{ c.nombre_camara || c.nombre || c.name || ('Cámara ' + c.id) }}
          </nb-option>
        </nb-select>
      </div>
    </nb-card-body>

    <nb-card-footer class="location-dialog__footer">
      <button nbButton ghost status="basic" type="button" (click)="closeUbicacionModal()">Cancelar</button>
      <button nbButton status="primary" type="button" [disabled]="!ubicacionTemporal" (click)="applyUbicacionModalSelection()">Aplicar</button>
    </nb-card-footer>
  </nb-card>
</ng-template>
